import styled, { css, keyframes } from 'styled-components'
import { rem } from 'utils/common'
import { fonts, merchantThemes, device } from 'components/Variable'

const blinkBtn = keyframes`
	0% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.1);
	}
	100% {
		transform: scale(1);
  }
`

export const Btn = styled.button`
	height: ${rem(44)};
	font-family: ${fonts.openSans};
	border: 1px solid transparent;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: none;
	padding: ${rem(13, 16)};
	transition: all 0.3s;
	text-decoration: none;
	text-align: center;
	min-width: ${rem(156)};
	font-weight: 600;
	font-size: ${rem(16)};
	line-height: ${rem(18)};
	border-radius: ${rem(2)};
	letter-spacing: ${rem(1.16667)};
	position: relative;
	transform: perspective(1px) translateZ(0);

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
    
	${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.henrylloyd &&
		css`
			font-family: ${fonts.Gotham};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
			border-radius: ${rem(22)};
			font-weight: normal;
			height: ${rem(33)};
			font-size: ${rem(15)};
			line-height: ${rem(20)};
			letter-spacing: ${rem(0.06)};
			padding: 0;
			text-transform: none;
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}
	
	@media (${device.laptopS}) {
		font-size: ${rem(14)};
		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				font-size: ${rem(15)};
			`}
	}

	@media (${device.tablet}) {
		min-width: ${rem(80)};
		font-size: ${rem(12)};
		height: ${rem(40)};
		padding: ${rem(10)};

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				font-size: ${rem(15)};
			`}
	}

	&:disabled,
	&[disabled],
	&.remove-exchange-item-control:disabled,
	&.dont-select-exchange-item-control:disabled,
	&.select-exchange-item-control:disabled,
	&[disabled]:hover {
		background-color: ${({ theme }) => theme.color.grayOne} !important;
		border-color: ${({ theme }) => theme.color.grayThirteen} !important;
		color: ${({ theme }) => theme.color.blackOne} !important;
		text-decoration: none !important;
		svg {
			fill: ${({ theme }) => theme.color.grayThirteen};
		}
	}

	&.remove-exchange-item-control:disabled,
	&.dont-select-exchange-item-control:disabled,
	&.select-exchange-item-control:disabled {
		color: ${({ theme }) => theme.color.graySix} !important;
	}

	${(props) =>
		props.w100 &&
		css`
			width: 100%;
			flex: 0 0 100%;
			max-width: 100%;
		`}

	${(props) =>
		props.w419 &&
		css`
			width: 100%;
			max-width: ${rem(419)};
			margin: 0 auto;
		`}
	
	${(props) =>
		props.uppercase &&
		css`
			text-transform: uppercase;
			${(p) =>
				p.theme.name === merchantThemes.toteme &&
				css`
					text-transform: none;
				`}
		`}
	
	${(p) =>
		p.icon &&
		css`
			padding: ${rem(13, 54)};
			border-color: rgba(0, 0, 0, 0.5);
			svg {
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
			}
		`}
	
	${(p) =>
		p.iconPosition === 'left'
			? css`
					svg {
						left: ${rem(15)};
						@media (${device.mobileL}) {
							left: ${rem(10)};
						}
					}
			  `
			: `
		svg{
			right: ${rem(15)};
		}
	`}
`

export const BtnFull = styled(Btn)`
	background-color: ${({ theme }) => theme.color.primary};
	border-color: ${({ theme }) => theme.color.primary};
	color: ${({ theme }) => theme.color.secondary};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			background-color: transparent;
			color: ${({ theme }) => theme.color.primary};
			border-radius: ${rem(32)};
			height: ${rem(33)};
			font-size: ${rem(15)};
			padding: 0;
			text-transform: none;

			svg {
				fill: ${({ theme }) => theme.color.primary};
			}
		`}

	svg {
		fill: ${({ theme }) => theme.color.secondary};
	}

	&:hover {
		background-color: transparent;
		color: ${({ theme }) => theme.color.primary};
		svg {
			fill: ${({ theme }) => theme.color.primary};
		}
	}

	&.secondary {
		background-color: ${({ theme }) => theme.color.blackOne};
		border-color: ${({ theme }) => theme.color.blackOne};
	}

	&.remove-exchange-item-control {
		background-color: ${({ theme }) =>
			theme.color.exchangeRemoveSelectBtnBgColor};
		border-color: ${({ theme }) =>
			theme.color.exchangeRemoveSelectBtnBorderColor};
		border-width: ${({ theme }) =>
			theme.color.exchangeRemoveSelectBtnBorderSize};
		color: ${({ theme }) => theme.color.exchangeRemoveSelectBtnTextColor};
		text-transform: uppercase;

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				text-transform: none;
			`}

		svg {
			fill: ${({ theme }) => theme.color.exchangeRemoveSelectBtnSVGColor};
		}
	}

	&.dont-select-exchange-item-control {
		background-color: ${({ theme }) =>
			theme.color.exchangeDontSelectBtnBgColor};
		border-color: ${({ theme }) =>
			theme.color.exchangeDontSelectBtnBorderColor};
		border-width: ${({ theme }) =>
			theme.color.exchangeDontSelectBtnBorderSize};
		color: ${({ theme }) => theme.color.exchangeDontSelectBtnTextColor};
		text-transform: uppercase;

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				text-transform: none;
			`}

		svg {
			fill: ${({ theme }) => theme.color.exchangeDontSelectBtnSVGColor};
		}
	}

	&.select-exchange-item-control {
		background-color: ${({ theme }) =>
			theme.color.exchangeSelectBtnBgColor};
		border-color: ${({ theme }) =>
			theme.color.exchangeSelectBtnBorderColor};
		border-width: ${({ theme }) => theme.color.exchangeSelectBtnBorderSize};
		color: ${({ theme }) => theme.color.exchangeSelectBtnTextColor};
		text-transform: uppercase;

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				text-transform: none;
			`}

		svg {
			fill: ${({ theme }) => theme.color.exchangeSelectBtnSVGColor};
		}
	}

	${(props) =>
		props.dark &&
		css`
			background-color: ${({ theme }) => theme.color.blackOne};
			border-color: ${({ theme }) => theme.color.blackOne};
			color: ${({ theme }) => theme.color.secondary};
			padding: ${rem(25, 0)};
			${(p) =>
				p.theme.name === merchantThemes.toteme &&
				css`
					background-color: transparent;
					color: ${({ theme }) => theme.color.primary};
					padding: 0;
					text-transform: none;
				`}

			&:hover {
				color: ${({ theme }) => theme.color.blackOne};
				svg {
					fill: ${({ theme }) => theme.color.blackOne};
				}
			}
		`};

	${(props) =>
		props.gray &&
		css`
			svg {
				fill: ${({ theme }) => theme.color.blackOne};
			}
			background-color: ${({ theme }) => theme.color.blackOne};
			border-color: ${({ theme }) => theme.color.blackOne};
			color: ${({ theme }) => theme.color.secondary};
			${(p) =>
				p.theme.name === merchantThemes.toteme &&
				css`
					background-color: transparent;
					color: ${({ theme }) => theme.color.primary};
					text-transform: none;
				`}
			&:hover {
				color: ${({ theme }) => theme.color.blackOne};
			}
		`};

	${(props) =>
		props.selected &&
		css`
			background-color: transparent;
			color: ${({ theme }) => theme.color.primary};
			svg {
				fill: ${({ theme }) => theme.color.primary};
			}
		`};

	${(props) =>
		props.inactive &&
		css`
			opacity: 0.5;
			cursor: not-allowed;
		`};

	${(p) =>
		p.theme.name === merchantThemes.musto &&
		css`
			background-color: ${({ theme }) => theme.color.primary};
			border-color: ${({ theme }) => theme.color.primary};
			color: ${({ theme }) => theme.color.secondary};
			&:hover {
				background-color: transparent;
				color: ${({ theme }) => theme.color.primary};
				svg {
					fill: ${({ theme }) => theme.color.primary};
				}
			}
		`}

	${(props) =>
		props.isLoading &&
		css`
			&:disabled,
			&[disabled] {
				background-color: ${({ theme }) =>
					theme.color.primary}!important;
				border-color: ${({ theme }) => theme.color.primary}!important;
				color: ${({ theme }) => theme.color.secondary}!important;
			}
		`};

	@media (${device.mobileL}) {
		${(p) =>
			p.isnavbtn &&
			css`
				width: ${rem(40)};
				height: ${rem(40)};
				min-width: ${rem(40)} !important;
				border-radius: 50%;
				&:not([disabled]) {
					animation: ${blinkBtn} 1s infinite alternate;
				}
			`}
	}
	&.yesButton {
		@media (${device.mobileL}) {
			margin-top: ${rem(16)};
			margin-left: ${rem(-10)};
			min-width: ${rem(298)};
		}
	}
`

export const BtnFlow = styled(Btn)`
	height: ${rem(40)};
	letter-spacing: ${rem(0.2)};
	background-color: ${({ theme }) => theme.color.grayOne};
	border-color: ${({ theme }) => theme.color.grayOne};
	color: ${({ theme }) => theme.color.blackOne};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			height: ${rem(33)};
			font-size: ${rem(15)};
			line-height: ${rem(20)};
			letter-spacing: ${rem(0.06)};
			padding: 0;
			text-transform: none;
		`}

	&:hover {
		background-color: ${({ theme }) => theme.color.secondary};
		border-color: ${({ theme }) => theme.color.primary};
		color: ${({ theme }) => theme.color.primary};
	}

	&:disabled,
	&[disabled] {
		background-color: ${({ theme }) => theme.color.grayOne}!important;
		border-color: ${({ theme }) => theme.color.grayThirteen}!important;
		color: ${({ theme }) => theme.color.blackOne}!important;
		text-decoration: none !important;

		svg {
			fill: ${({ theme }) => theme.color.grayThirteen} !important;
		}
	}
`

export const BtnBorder = styled(Btn)`
	background-color: transparent;
	border-color: ${({ theme }) => theme.color.blackOne};
	color: ${({ theme }) => theme.color.blackOne};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			height: ${rem(33)};
			padding: 0;
		`}

	svg {
		fill: ${({ theme }) => theme.color.blackOne};
	}
	&:hover {
		background-color: ${({ theme }) => theme.color.blackOne};
		border-color: ${({ theme }) => theme.color.blackOne};
		color: ${({ theme }) => theme.color.secondary};
		svg {
			fill: ${({ theme }) => theme.color.secondary};
		}
	}
	&:disabled,
	&[disabled] {
		background-color: ${({ theme }) => theme.color.grayOne}!important;
		border-color: ${({ theme }) => theme.color.grayThirteen}!important;
		color: ${({ theme }) => theme.color.blackOne}!important;
		text-decoration: none !important;
		cursor: not-allowed;

		svg {
			fill: ${({ theme }) => theme.color.grayThirteen} !important;
		}
	}

	&.flow-btn-original {
		background-color: ${({ theme }) =>
			theme.color.flowButtonOriginalBgColor};
		border-color: ${({ theme }) =>
			theme.color.flowButtonOriginalBorderColor};
		color: ${({ theme }) => theme.color.flowButtonOriginalTextColor};
	}

	&.btn-active {
		background-color: ${({ theme }) => theme.color.blackOne};
		border-color: ${({ theme }) => theme.color.blackOne};
		color: ${({ theme }) => theme.color.secondary};
	}

	${(p) =>
		p.isOpen &&
		css`
			svg {
				transform: translateY(-50%) rotate(-180deg);
			}
		`}

	@media (${device.tablet}) {
		${(p) =>
			p.isnavbtn &&
			css`
				&:disabled,
				&[disabled] {
					opacity: 0.22;
				}
			`}
	}

	@media (${device.mobileL}) {
		${(p) =>
			p.isnavbtn &&
			css`
				width: ${rem(40)};
				height: ${rem(40)};
				min-width: ${rem(40)} !important;
				border-radius: 50%;
				svg {
					fill: ${({ theme }) => theme.color.secondary};
				}
				&:disabled,
				&[disabled] {
					opacity: 0.15;
				}
			`}
	}

	@media (${device.mobileM}) {
		margin-bottom: ${rem(10)};
		&.buttonBack {
			margin-bottom: 0;
		}
	}
	&.noButton {
		@media (${device.mobileL}) {
			margin-left: ${rem(-10)};
			margin-bottom: ${rem(-8)};
			min-width: ${rem(298)};
		}
	}
`
